export const SVGParallelogram = ({ children, style = {}, width = 450, height = 100, color = '#0C3C78', skewAmount = 20 }) => (
    <div style={{ position: 'relative', display: 'inline-block' }}>
        <svg width={width + skewAmount} height={height}>
            <polygon
                points={`0,0 ,${width - skewAmount},0 ${width},${height} 0,${height}`}
                fill={color}
                stroke={color}
                strokeWidth="2"
            />
            <text
                x={(width + skewAmount) / 2}
                y={height / 2 + 15}
                textAnchor="middle"
                fill="white"
                fontSize="16"
                fontWeight="bold"
                style={style}
            >
                {children}
            </text>
        </svg>
    </div>
);